"use client";

import type { Interpolation } from "@emotion/react";
import { Link, useTranslations } from "@i18n/next";
import type { AnalyticsEvent, HallowAnalyticsEvent } from "@packages/analytics";
import { useAnalytics } from "@packages/analytics";
import { URL_ONBOARDING } from "@packages/sdk";
import type { ButtonProps } from "@packages/ui";
import { Button } from "@packages/ui";
import type { PropsWithChildren } from "react";

export type CTAProps = Omit<ButtonProps, "onClickCapture"> &
  PropsWithChildren<{
    event: HallowAnalyticsEvent;
    eventProperties: AnalyticsEvent["properties"];
    css?: Interpolation;
  }>;

export const CTA = ({
  event,
  eventProperties,
  children,
  ...props
}: CTAProps) => {
  const t = useTranslations();
  const analytics = useAnalytics();
  return (
    <Button
      asChild
      {...(props as ButtonProps)}
      onClickCapture={() =>
        analytics.track({ event, properties: eventProperties })
      }
    >
      <Link href={URL_ONBOARDING}>{children ?? t("try_hallow_for_free")}</Link>
    </Button>
  );
};
